import "./AiInfoBoxBlock.scss";
import { Link } from "/App.Components";
import { AiInfoBoxBlockProps } from "/Models/Generated/AiInfoBoxBlockProps";

const AiInfoBoxblock = ({
  heading,
  description,
  contactLink,
}: AiInfoBoxBlockProps) => {
  return (
    <div className="ai-info-box-block-norad">
      {heading && <h2 className="ai-info-box-block-norad__title">{heading}</h2>}
      {description && (
        <p className="ai-info-box-block-norad__description">{description}</p>
      )}
      {contactLink && <Link {...contactLink} size="x-small" hasUnderline />}
    </div>
  );
};

export default AiInfoBoxblock;
